import { SIZE } from '@app/src/ui';
import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  padding: 0 15px;

  @media (min-width ${SIZE.TABLET_LANDSCAPE}) {
    padding: 0;
  }
`;